import React from 'react'
import { Combobox } from 'react-widgets';

const Pagination = ({
  data,
  currentPage,
  setCurrentPage,
  perPage
}) => {
  const currentRangeStart = (currentPage - 1) * perPage + 1;
  const currentRangeEnd = Math.min(currentPage * perPage, data.length);

  const pagination = [];
  for (let i = 1; i <= Math.ceil(data.length / perPage); i++) {
    pagination.push({ value: i.toString(), name: i.toString() });
  }

  const handlePageChange = (event) => {
    setCurrentPage(event.value);
  };

  const handleNextPage = () => {
    setCurrentPage((prevPage) => prevPage + 1);
  };

  const handlePrevPage = () => {
    setCurrentPage((prevPage) => prevPage - 1);
  };

  const handleFirstPage = () => {
    setCurrentPage(1);
  };

  const handleLastPage = () => {
    setCurrentPage(Math.ceil(data.length / perPage));
  };

  return (
    <>
      <div className="flex justify-end">
        <nav className="flex items-center">
          <Combobox
            dropUp
            className="paging-box"
            data={ pagination }
            value={ currentPage }
            dataKey='value'
            textField='name'
            onSelect={ handlePageChange }
            filter='contains'
          />

          <div className="flex justify-center p-2 border border-border bg-white rounded-l-[10px] shadow ml-1">
            <p className="text-xs text-gray-500">
              <span className='font-semibold'>{currentRangeStart} - {currentRangeEnd}</span> of {data.length}
            </p>
          </div>

          <button
            onClick={handleFirstPage}
            disabled={currentPage === 1 || data.length === 0}
            className="px-3 py-2 h-full text-xs font-medium focus:outline-none transition duration-150 text-gray-400 hover:text-gray-600 disabled:hover:text-gray-400 disabled:bg-gray-100 focus-within:outline-none focus-visible:outline-none border border-l-0 border-border bg-white shadow"
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor" className="w-3.5 h-3.5">
              <path strokeLinecap="round" strokeLinejoin="round" d="M18.75 19.5l-7.5-7.5 7.5-7.5m-6 15L5.25 12l7.5-7.5" />
            </svg>
          </button>

          <button
            onClick={handlePrevPage}
            disabled={currentPage === 1 || data.length === 0}
            className="px-3 py-2 h-full text-xs font-medium focus:outline-none transition duration-150 text-gray-400 hover:text-gray-600 disabled:hover:text-gray-400 disabled:bg-gray-100 focus-within:outline-none focus-visible:outline-none border border-l-0 border-border bg-white shadow"
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor" className="w-3.5 h-3.5">
              <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
            </svg>
          </button>

          <button
            onClick={handleNextPage}
            disabled={currentPage === Math.ceil(data.length / perPage) || data.length === 0}
            className="px-3 py-2 h-full text-xs font-medium focus:outline-none transition duration-150 text-gray-400 hover:text-gray-600 disabled:hover:text-gray-400 disabled:bg-gray-100 focus-within:outline-none focus-visible:outline-none border border-l-0 border-border bg-white shadow"
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor" className="w-3.5 h-3.5">
              <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
            </svg>
          </button>

          <button
            onClick={handleLastPage}
            disabled={currentPage === Math.ceil(data.length / perPage) || data.length === 0}
            className="px-3 py-2 h-full text-xs font-medium focus:outline-none transition duration-150 text-gray-400 hover:text-gray-600 disabled:hover:text-gray-400 disabled:bg-gray-100 focus-within:outline-none focus-visible:outline-none border border-l-0 rounded-r-[10px] border-border bg-white shadow"
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor" className="w-3.5 h-3.5">
              <path strokeLinecap="round" strokeLinejoin="round" d="M11.25 4.5l7.5 7.5-7.5 7.5m-6-15l7.5 7.5-7.5 7.5" />
            </svg>
          </button>
        </nav>
      </div>
    </>
  )
}

export default Pagination